import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  IconButton,
  Grid,
  Paper,
  CardMedia,
} from "@mui/material";
//import { API_DOMAIN } from "../../../constants";
const API_DOMAIN = "https://capacitamos.com/online"
import AudioPlayer from "../../AudioPlayer";
import "./styles.css";
import { styled, keyframes } from "@mui/material/styles";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import parse from 'html-react-parser';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
`;

const RecordingIconButton = styled(IconButton)(({ isRecording }) => ({
  width: '64px',
  height: '64px',
  border: isRecording ? '4px solid #005375' : '4px solid #FFA500',
  borderRadius: '50%',
  transition: 'border 0.3s',
  animation: isRecording ? `${pulse} 1.5s infinite` : 'none',
  '& svg': {
    fontSize: '32px',
    color: isRecording ? '#005375' : '#FFA500',
    transition: 'color 0.3s',
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

var SpeechRecognition = window.SpeechRecognition ? window.SpeechRecognition : window.webkitSpeechRecognition;
var SpeechGrammarList = window.SpeechGrammarList ? window.SpeechGrammarList : window.webkitSpeechGrammarList;
var SpeechRecognitionEvent = window.SpeechRecognitionEvent ? window.SpeechRecognitionEvent : window.webkitSpeechRecognitionEvent;

const PronunciationLesson = ({ question, setAnswer, courseCode }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [answer, setAnswerR] = useState("")
  const [phraseResult, setPhraseResult] = useState("")
  const [isCorrectPhrase, setIsCorrectFrase] = useState(false)
  const [textMessage, setTextMessage] = useState("Para una mejor experiencia se sugiere el uso de micrófono, diadema o manos libres. Recuerda usar solo Google Chrome.")
  const recognition = new SpeechRecognition();
  const minPercentaje = 70;
  const words = [question.frase];

  if (SpeechGrammarList) {
    // SpeechGrammarList is not currently available in Safari, and does not have any effect in any other browser.
    // This code is provided as a demonstration of possible capability. You may choose not to use it.
    var speechRecognitionList = new SpeechGrammarList();
    var grammar = '#JSGF V1.0; grammar colors; public <color> = ' + words.join(' | ') + ' ;'
    speechRecognitionList.addFromString(grammar, 1);
    recognition.grammars = speechRecognitionList;
  }
  recognition.continuous = false;
  recognition.lang = 'en-US';
  recognition.interimResults = false;
  recognition.maxAlternatives = 1;


  recognition.onresult = function(event) {
  
    let color = event.results[0][0].transcript;
    color=color.toUpperCase();
    //diagnostic.textContent = color;
    
    let valueAnswer = 0;
    const conf=event.results[0][0].confidence * 100;
    setPercentage(Math.round(conf))
    console.log(conf)
    setPhraseResult(color)
    if (color == question.frase.toUpperCase()){ 
      let messageTemp = Math.round(conf).toString()+"% de efectividad en la pronunciación. "
      
      if (conf>=70){
        messageTemp +="<br>Aprobado. De click en Aceptar.";
        setIsCorrectFrase(true)
        valueAnswer = 1
      }else{
        messageTemp += "<br>Debes mejorar la pronunciación. Intenta de nuevo.";
      }

      setTextMessage(messageTemp)
      //confianza.style="background-color:blue;";
      
    }else{
      setPercentage(0)
      setTextMessage("No es la frase indicada. Intenta de nuevo ");
    }
    //confianza.value=conf;
    setAnswerR(question.id +"-"+ valueAnswer.toString())
  }
  
  recognition.onspeechend = function() {
    setIsRecording(false);
    recognition.stop();
  }
  
  recognition.onnomatch = function(event) {
    setIsRecording(false);
    setAnswerR(question.id + "-0")
    setPercentage(0)
    setTextMessage("Frase no reconocida... ");
  }
  
  recognition.onerror = function(event) {
    setIsRecording(false);
    setAnswerR(question.id + "-0")
    setPercentage(0)
    setTextMessage("Error en el reconocimiento. Error "+event.error);
  }


  const handleClick = () => {
    setPhraseResult("")
    if (!isRecording) {
      recognition.start();
    }
    setIsRecording(true);
  };

  useEffect(()=> {
    if (answer) {
      setAnswer(answer);
    }
  }, [answer])
  return (
    <Grid container columns={{ xs: 4, md: 12 }} sx={{ padding: 5 }}>
      <Typography variant="h5" color="primary" sx={{ mb: 2 }}>
        {question.frase}
        <Box sx={{ ml: 1, display: "inline-block" }}>
          <AudioPlayer
          additinalClass={'pronunciation'}
            audioUrl={`${API_DOMAIN}/contents/cursos/${courseCode}/audios/${question.audio}`}
            key={question.audio}
          />
        </Box>
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <CardMedia
            component="img"
            style={{ maxWidth: 250, height: "auto", margin: "auto" }}
            image={`${API_DOMAIN}/contents/cursos/${courseCode}/img/${question.imagen}`}
            loading="lazy"
          />
        </Grid>
        <Grid item xs={6}>
          <Paper elevation={3} sx={{ p: 2, textAlign: "center" }}>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 2 }}>
              Da click en el micrófono y repite la frase indicada...
            </Typography>
            {phraseResult ? (
            <Typography variant="body1" color="textPrimary" sx={{ mb: 2 }}>
              {phraseResult}
            </Typography>
            ):null}
            <RecordingIconButton
              isRecording={isRecording}
              onClick={handleClick}
            >
              {isRecording ? <MicIcon /> : <MicOffIcon />}
            </RecordingIconButton>
            <Box sx={{ width: "100%", my: 2 }}>
              <Box
                sx={{
                  height: 8,
                  backgroundColor: "#c4c4c4",
                  borderRadius: 4,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: `${percentage}%`,
                    height: "100%",
                    backgroundColor: `${minPercentaje >= percentage ? 'red' : '#3f51b5'} `,
                  }}
                ></Box>
              </Box>
            </Box>
            
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              {parse(textMessage)}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PronunciationLesson;
